<template>
  <div class="copay-epa-source-filter-list">
    <b-table
      striped
      hover
      :fields="gridFields"
      :busy="busy"
      :items="searchResults"
      :sort:by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      @sort-changed="changeSorting"
    >
      <div slot="table-busy" class="text-center my-2">
        <i class="fa fa-spinner fa-pulse"></i>
        <strong>Working...</strong>
      </div>
      <template slot="selected" slot-scope="data">
        <b-form-checkbox
          v-bind:checked="isAssigned(data.item)"
          @change="change(data.item)"
        >
        </b-form-checkbox>
      </template>
      <template slot="copay_offer_name" slot-scope="data">
        {{data.value}}
      </template>
      <template slot="manufacture_name" slot-scope="data">
        {{data.value}}
      </template>
      <template slot="drug_name" slot-scope="data">
        {{data.value}}
      </template>
      <template slot="current_status" slot-scope="data">
        {{getEffectiveStatus(data.item) | snakeToTitleCase}}
      </template>
    </b-table>
  </div>
</template>
<script>
export default {
  name: "VBrandLimitOfferEditList",
  data() {
    return {
      sortBy: "copay_offer_name",
      sortDesc: false
    };
  },
  props: {
    searchResults: {
      required: true,
      type: Array
    },
    selectedOffers: {
      required: true,
      type: Array
    },
    busy: {
      required: false,
      type: Boolean
    }
  },
  computed: {
    gridFields: {
      get() {
        let fields = [];
        fields.push({key: "selected", class: "selected-field", label: "", sortable: false});
        fields.push({key: "copay_offer_name", class: "default-field", label: "Offer", sortable: true});
        fields.push({key: "manufacture_name", class: "default-field", label: "Manufacturer", sortable: true});
        fields.push({key: "drug_name", class: "default-field", label: "Drug", sortable: true});
        fields.push({key: "current_status", class: "status-field", label: "Offer Status", sortable: true});
        return fields;
      }
    }
  },
  methods: {
    isAssigned(offer) {
      const result = this.selectedOffers.find(o => o.copay_offer_id === offer.copay_offer_id);
      if (result !== undefined) {
        return true;
      }
      return false;
    },
    changeSorting(ctx) {
      this.sortDesc = ctx.sortDesc;
      this.sortBy = ctx.sortBy;
    },
    change(offer) {
      const foundOffer = this.selectedOffers.find(o => o.copay_offer_id === offer.copay_offer_id);
      if (foundOffer !== undefined) {
        const index = this.selectedOffers.indexOf(foundOffer);
        this.selectedOffers.splice(index, 1);
      } else {
        this.selectedOffers.push(offer);
      }
    },
    getEffectiveStatus(item) {
      const now = new Date().toISOString();
      if (
        item.current_offer_effective_date &&
        now < item.current_offer_effective_date
      ) {
        return `inactive until ${new Date(
          item.current_offer_effective_date
        ).toLocaleDateString()}`;
      } else if (
        item.current_offer_end_date &&
        item.current_offer_end_date < now
      ) {
        return "inactive";
      } else if (
        item.current_status === "active" &&
        item.current_offer_end_date &&
        item.current_offer_end_date > now &&
        item.current_offer_end_date.indexOf('2099-01-01') === -1
      ) {
        return `active until ${new Date(
          item.current_offer_end_date
        ).toLocaleDateString()}`;
      }
      return item.current_status;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/VBrandLimitOfferEditList.vue